import { Transform, Type } from 'class-transformer'
import { ArrayMaxSize, IsArray, IsIn, IsInt, IsOptional, IsString, MaxLength, Min } from 'class-validator'
import 'reflect-metadata'

export class V2Ingredient {
  id!: number
  homologaId?: string
  name!: string
  pesticideType?: string
  identificationNumber?: string
  referenceIngredient?: string
  /** Number of catalogue products containing this ingredient */
  productsCount!: number
}

export const V2_INGREDIENT_SORT_COLUMNS = [
  'name',
  'pesticideType',
  'identificationNumber',
  'referenceIngredient',
  'productsCount',
] as const
export type V2IngredientSort = (typeof V2_INGREDIENT_SORT_COLUMNS)[number]

export class V2IngredientQuery {
  /** Part of the name, type, identification number or reference ingredient */
  @IsOptional()
  @IsString()
  @MaxLength(255)
  search?: string

  /** Pesticide types, any case or plural variant; a single value arrives as a string in the query */
  @IsOptional()
  @Transform(({ value }: { value: unknown }) => (value === undefined ? undefined : [value].flat()))
  @IsArray()
  @ArrayMaxSize(50)
  @IsString({ each: true })
  @MaxLength(90, { each: true })
  pesticideTypes?: string[]

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  page = 1

  @IsOptional()
  @IsIn(V2_INGREDIENT_SORT_COLUMNS)
  sort: V2IngredientSort = 'name'

  @IsOptional()
  @IsIn(['asc', 'desc'])
  direction: 'asc' | 'desc' = 'asc'
}

export interface V2IngredientPage {
  data: V2Ingredient[]
  currentPage: number
  resultsCount: number
  pageCount: number
}

export interface V2IngredientOptions {
  /** Pesticide types of the ingredients, case and plural variants grouped */
  pesticideTypes: string[]
}
